var heading_default = {
  "fontElementMap": "A6LL8",
  "elementSpacing": "N7LoW",
  "headerOne": "uYY3Z N7LoW",
  "headerTwo": "-eG6Q N7LoW",
  "headerThree": "UiJd9 N7LoW",
  "headerFour": "eWQ-u N7LoW",
  "headerFive": "prlNi N7LoW",
  "headerSix": "LmThU N7LoW",
  "child": "_0MIeX"
};
export {
  heading_default as default
};
//# sourceMappingURL=heading-scss.js.map
